
import React, { useEffect, useMemo, useRef, useState } from 'react';
import MapView from '@arcgis/core/views/MapView';
import Map from '@arcgis/core/Map';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Home from "@arcgis/core/widgets/Home";
import Popup from "@arcgis/core/widgets/Popup";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Expand from "@arcgis/core/widgets/Expand.js";
import Graphic from "@arcgis/core/Graphic.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Legend from '@arcgis/core/widgets/Legend';
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Table from './Table';
import { setSelectedBuffer } from "../store/slice/bufferSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loader from './Loader';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { setIsSidebar } from '../store/slice/currentStageSlice';
import { setIsBufferWidth } from '../store/slice/currentStageSlice';
import Query from '@arcgis/core/rest/support/Query';
const MapUlbView = ({ selectedLayer, onViewReady, isWidth, isScreenSize, isByDefaultActive, locationAi }) => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation()
  const [view, setView] = useState(null);
  const [isDrag, setIsDrag] = useState(false);
  const [isAccordian, setIsAccordian] = useState('');
  const [tabLocation, setTabLocation] = useState(false);
  const [isLayerListExpanded, setIsLayerListExpanded] = useState(false);
  const [updatedTableData, setUpdatedTableData] = useState([]);
  const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
  const features = bufferData[selectedBuffer] || [];
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
  const [loading, setLoading] = useState(true); // Loader state
  const { isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
  const { isDistCd, isUlbCd, isWardNo } = useSelector((state) => state.currentStage)

  const authData = useSelector(state => state.authToken.authData);

  console.log("isDistCd", isDistCd)
  console.log("isUlbCd", isUlbCd)
  console.log("isWardNo", isWardNo)

  const handleDrag = () => {
    setIsDrag(!isDrag)
  }

  const layerUrls = [
    //Admin Boundary  0-13
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/1", title: "State" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/2", title: "Division" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/3", title: "District" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/4", title: "Tehsil" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/5", title: "Municipal Area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/6", title: "Municipal Zone Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/7", title: "Municipal Ward Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/8", title: "Municipal Taxratezone Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/9", title: "Cantonment Areas" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/10", title: "Planning_area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/11", title: "Urbanagglomerationarea" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/12", title: "Village_boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/13", title: "Khasra" },
    //Property 14-27
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/14", title: "Property" },
    //{ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97", title: "MP Property" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/15", title: "Plot Building Structure" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/16", title: "BuiltUp Area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/17", title: "Spatial DistributionOf Slums" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/18", title: "VillageSettlement Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/19", title: "VillageSettlementy_bfp" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/20", title: "Temporary Shades" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/21", title: "Commercial Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/22", title: "Planning BuiltupArea" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/23", title: "PowerPlant" },
    // { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/24", title: "MP Grid" },
    // { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/25", title: "MP Grid Slum" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/26", title: "Slum DemarcationPoint" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/27", title: "Ward Gazzete NotificationPoints" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/28", title: "Slum Gazatte NotificationPoint" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/29", title: "TaxRate Gazette NotificationPoint" },

    //Land use Land Cover 27-42
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/30", title: "Agricultural Area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/31", title: "Existing Landuse" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/32", title: "Forest" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/33", title: "Vacantlands" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/34", title: "Wastelands" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/35", title: "Hillarea" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/36", title: "Openland" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/37", title: "Traffic_island" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/38", title: "Playground" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/39", title: "Industrial_area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/40", title: "Minning_area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/41", title: "Plantation" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/42", title: "Orchyard" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/43", title: "Park" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/44", title: "Planning_lulc" },

    //Transportation

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/45", title: "RoadCenterline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/46", title: "Road_polygon", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/47", title: "RoadEdgeLine", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/48", title: "Divider", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/49", title: "Flyover", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/50", title: "Lane", popupEnabled: Popup },

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/51", title: "Footpath", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/52", title: "Bridge_poi", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/53", title: "Bridge_line", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/54", title: "Bridge_poly", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/55", title: "Culvert", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/56", title: "RailwayCenterline", popupEnabled: Popup },


    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/57", title: "Railway_poly", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/58", title: "Railway_property", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/59", title: "RailwayStation", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/60", title: "Railway_gate", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/61", title: "AirCraftRoad", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/62", title: "Airport_poi", popupEnabled: Popup },

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/63", title: "Helipad", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/64", title: "Busstand", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/65", title: "Planning_RoadCenterline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/66", title: "Planning_RailwayCenterline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/67", title: "Planning_Railwaypoly", popupEnabled: Popup },

    //Waterbodies
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/68", title: "RiverCenterline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/69", title: "Rivers", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/70", title: "Drainage or Nala", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/71", title: "Drains", popupEnabled: Popup },

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/72", title: "Obscured Drain", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/73", title: "Canal Centerline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/74", title: "Canals", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/75", title: "WaterBodies", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/76", title: "Dam", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/77", title: "OverheadTank", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/78", title: "Wells", popupEnabled: Popup },

    //Important Landmarks

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/79", title: "Importantlandmarks", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/80", title: "ColonyName", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/81", title: "Villagelocation", popupEnabled: Popup },

    //Utilities
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/82", title: "Electrical Network" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/83", title: "FireStation" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/84", title: "Markets" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/85", title: "Pipeline" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/86", title: "Telecommunication" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/87", title: "Toilets" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/88", title: "Trafficmgmt" },



    //Others
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/89", title: "Telecommunication" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/90", title: "Toilets" },


    //{ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97", title: "MP Property information" },




  ];

  useEffect(() => {
    if (location.pathname === "/user-chatbot") {
      console.log("i am gis")
      setTabLocation(true)
    }
  }, [location])

  const group1 = new GroupLayer({
    title: "Administrative Boundaries",
    visible: true,
    layers: layerUrls.slice(0, 13).map((layer, index) => {
      const layerDef = {
        url: layer.url,
        // maxScale: 18000, // Zoom level ~15
        maxScale: 1128, // restricts zoom in to level 20
        title: layer.title,
        visible: [0, 2, 4].includes(index) // Only layers 0, 2, and 4 are visible
      };

      if (authData?.UserType === "User") {
        // Apply filters only for viewers
        if (index === 4) { // Municipal Area layer (ULB boundary)
          layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
          layerDef.visible = true;
        } else if (index === 6) { // Municipal Ward Boundary
          layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        } else if (index === 2) { // District layer
          layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}'`;
        } else {
          layerDef.visible = false;
        }
      } else {
        // For non-viewers, skip applying filters but still control visibility
        if (index !== 4 && index !== 6 && index !== 2) {
          layerDef.visible = false;
        }
      }
      return new FeatureLayer(layerDef);
    })
  });

  const group2 = new GroupLayer({
    title: "Property",
    visible: false, // Keep property layers hidden by default
    layers: layerUrls.slice(13, 26).map(layer => {
      const layerDef = {
        url: layer.url,
        title: layer.title,
        visible: false // Hide all property layers by default
      };

      // Apply filters based on layer type and user role
      if (authData?.UserType === "User") {
        // Property layer (index 14)
        if (layer.title === "Property") {
          layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
          layerDef.visible = true; // Only make the main Property layer visible
        }
        // Other property-related layers (like BuiltUp Area, Commercial Boundary etc.)
        else if (["BuiltUp Area", "Commercial Boundary", "Plot Building Structure"].includes(layer.title)) {
          layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        }
        // For other property-related layers, keep them hidden
        else {
          layerDef.definitionExpression = `1=0`; // This ensures no features will show
        }
      } else {
        // For non-Viewer roles, still filter by ULB but keep visible
        //layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        layerDef.definitionExpression = '1=1';
      }

      return new FeatureLayer(layerDef);
    })
  });

    const group3 = new GroupLayer({
    title: "Landuse and Landcover",
    visible: false, // Hidden by default
    layers: layerUrls.slice(27, 42).map(layer =>
      new FeatureLayer({
        url: layer.url,
        title: layer.title,
        // definitionExpression: getDefinitionExpression(layer.title, authData),
        visible: layer.title === "Existing Landuse" // Only show key layers by default
      })
    )
  });

  const group4 = new GroupLayer({
    title: "Transportation",
    visible: true,
    layers: layerUrls.slice(42, 65).map(layer =>
      new FeatureLayer({
        url: layer.url,
        title: layer.title,
        minScale: 288895.277144,   // Zoom level 12
        maxScale: 70.5310735,    // Restrict zoom beyond this scale
        // definitionExpression: getDefinitionExpression(layer.title, authData),
        visible: ["RoadCenterline", "RailwayCenterline"].includes(layer.title) // Show main road layers
      })
    )
  });

  const group5 = new GroupLayer({
    title: "Waterbodies",
    visible: false,
    layers: layerUrls.slice(65, 76).map(layer =>
      new FeatureLayer({
        url: layer.url,
        title: layer.title,
        // definitionExpression: getDefinitionExpression(layer.title, authData),
        visible: ["Rivers", "WaterBodies"].includes(layer.title) // Show main water features
      })
    )
  });

  const group6 = new GroupLayer({
    title: "Important Landmarks",
    visible: false,
    layers: layerUrls.slice(76, 79).map(layer =>
      new FeatureLayer({
        url: layer.url,
        title: layer.title,
        //definitionExpression: getDefinitionExpression(layer.title, authData)
      })
    )
  });

  const group7 = new GroupLayer({
    title: "Utilities",
    visible: false,
    layers: layerUrls.slice(79, 86).map(layer =>
      new FeatureLayer({
        url: layer.url,
        title: layer.title,
        // definitionExpression: getDefinitionExpression(layer.title, authData)
      })
    )
  });

  const group8 = new GroupLayer({
    title: "Others",
    visible: false,
    layers: layerUrls.slice(86, 88).map(layer =>
      new FeatureLayer({
        url: layer.url,
        title: layer.title,
        //definitionExpression: getDefinitionExpression(layer.title, authData)
      })
    )
  });


    //sewarage 

        const sewerageProjectLayer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer",
          sublayers: [
            {
              id: 1,
              title: "STP",
              visible: true
            },
            {
              id: 2,
              title: "MPS",
              visible: true
            },
            {
              id: 3,
              title: "IPS",
              visible: true
            },
            {
              id: 4,
              title: "Manhole",
              visible: true
            },
            {
              id: 5,
              title: "Sewer Network",
              visible: true
            }
          ]
        });


        // Create a group layer to contain the sewerage layers
        const sewerageGroupLayer = new GroupLayer({
          title: "Sewerage Project Layers",
          visible: false,
          layers: [sewerageProjectLayer]
        });

        //watersupply_project

        const watersupplyProjectLayer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer",
          sublayers: [
            {
              id: 1,
              title: "WTP",
              visible: true
            },
            {
              id: 2,
              title: "Intake Well",
              visible: true
            },
            {
              id: 3,
              title: "OHT",
              visible: true
            },
            {
              id: 4,
              title: "Junction",
              visible: true
            },
            {
              id: 5,
              title: "RWPM",
              visible: true
            },
            {
              id: 6,
              title: "CWPM",
              visible: true
            },
            {
              id: 7,
              title: "Distribution Network",
              visible: true
            }
          ]
        });


        // Create a group layer to contain the sewerage layers
        const watersupplyGroupLayer = new GroupLayer({
          title: "Watersupply Project Layers",
          visible: false,
          layers: [watersupplyProjectLayer]
        });



        //sampda_guideline


        const SampadaGuidelineLayer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer",
          sublayers: [
            {
              id: 1,
              title: "Sampada Guideline",
              visible: true
            }

          ]
        });


        // Create a group layer to contain the sewerage layers
        const sampadaGuidelineGroupLayer = new GroupLayer({
          title: "Sampada Guideline ",
          visible: false,
          layers: [SampadaGuidelineLayer]
        });





  useEffect(() => {
    let mapView;

    const initializeMap = async () => {
      try {
        setLoading(true);

        const towns = ["UJJAIN", "SINGRAULI", "SHIVPURI", "SEONI", "SATNA"];
        const masterPlanLayers = towns.map(town => {
          const config = {
            url: "https://urbangis.mp.gov.in/server/rest/services/Master_Plan_MIL1/MapServer/0",
            outFields: ["*"],
            title: town,
            visible: false
          };

          if (authData?.UserType === "districtuser" || authData?.UserType === "User" && authData?.DistrictName?.toUpperCase() === town) {
            config.definitionExpression = `Town_Name = '${town}'`;
            config.visible = true;
          } else {
            config.definitionExpression = `Town_Name = '${town}'`;
          }

          return new FeatureLayer(config);
        });

        const masterPlanGroup = new GroupLayer({
          title: "Master Plan",
          layers: masterPlanLayers,
          visible: false
        });

        const basemapLayers = [
          new FeatureLayer({ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/5", title: "Municipal Area", visible: true }),
          new FeatureLayer({ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/7", title: "Municipal Ward Boundary", visible: true }),
          new FeatureLayer({ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/15", title: "Plot Building Structure", visible: true }),
          new FeatureLayer({ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/45", title: "Road Centerline", visible: true }),
          new FeatureLayer({ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/56", title: "Railway Centerline", visible: true }),
          new FeatureLayer({ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/75", title: "Waterbodies", visible: true }),
          new FeatureLayer({ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/79", title: "Important Landmarks", visible: true })
        ];

        const basemapGroup = new GroupLayer({
          title: "Basemap",
          layers: basemapLayers,
          visible: true
        });

          const popupTemplate = {
          title: "Property Info",
          content: function (feature) {
            const attributes = feature.graphic.attributes;

            // Determine the label based on isuseres
            let label = "";
            switch (attributes.isuseres) {
              case "Yes":
                label = "Residential";
                break;
              case "No":
                label = "Commercial";
                break;
              case "Mix Use":
                label = "Both";
                break;
              default:
                label = attributes.isuseres || "N/A";
            }

            return `
            <div style="min-height: 300px; overflow-y: auto;">
              <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                <tr>
                  <th style="border: 1px solid #ddd; padding: 4px;">Field</th>
                  <th style="border: 1px solid #ddd; padding: 4px;">Value</th>  
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Ulb Name:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.ulbname}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>GIS Uniqueid ID:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.gis_uniqueid}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>E_NagarPalika ID:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.e_nagarpalikaid}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Property Type:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${label}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Wardno:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.wardno}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Owner Name:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.ownername}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Mobile No:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.mobileno}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Plot Size:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.plotsize}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Floor Details:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.floor_details}</td>
                </tr>
               
              </table>
            </div>`;
          }
        };

          const getPropertyLayerDefinition = () => {
          if (authData?.UserType === "User" || authData?.UserType === "districtuser") {
            try {
              // const expression = `ulb_cd = '${authData?.Ulb_Code}' AND wardno = '${authData?.WardNo}'`;
              const expression = `ulb_cd = '${authData?.Ulb_Code}'`;
              console.log("Applying PropertyFeatureLayer filter:", expression);
              return expression;
            } catch (error) {
              console.error("Error creating definition expression:", error);
              return undefined;
            }
          }
          return undefined;
        };

        const PropertyFeatureLayer = new FeatureLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97",
          outFields: ["*"],
           title: "Property Info",
          popupTemplate: popupTemplate,
        minScale: 1128.497220 , // Zoom level ~19
          maxScale: 70.5310735,     // Zoom level ~23
         // maxScale: 70,
          renderer: {
            type: "simple",
            symbol: {
              type: "simple-fill",
              color: null,
              outline: {
                color: "#90EE90",
                width: 1
              }
            }
          },
          definitionExpression: getPropertyLayerDefinition()
        });

        const map = new Map({
          basemap: "streets", //,topo-vector ,streets ,hybrid ,satellite
          layers: [sampadaGuidelineGroupLayer, watersupplyGroupLayer, sewerageGroupLayer,PropertyFeatureLayer,basemapGroup,group8, group7, group6, group5, group4, group3, group2, group1, masterPlanGroup]
        });

        mapView = new MapView({
          container: mapRef.current,
          map,
          center: [78.746567, 23.83403],
          zoom: 6,
          popup: new Popup({
            dockEnabled: true,
            dockOptions: { position: "bottom-right", buttonEnabled: false, breakpoint: false }
          })
        });

        setView(mapView);
        if (onViewReady) onViewReady(mapView);

        mapView.when(() => {
          setLoading(false);

         mapView.ui.remove("zoom");

          mapView.ui.add(new Search({ view: mapView }), { position: "top-left", index: 2 })
          mapView.ui.add(new Home({ view: mapView }), "top-left");
          mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");
          mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
          mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");

          const legend = new Legend({
            view: mapView,
            layerInfos: [
              { layer: group2, title: "Property" },
              { layer: group1, title: "Administrative Boundaries" }
            ]
          });
          mapView.ui.add(new Expand({ view: mapView, content: legend }), "top-right");

          const printWidget = new Print({
            view: mapView,
           // printServiceUrl:"https://urbangis.mp.gov.in/server/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
             printServiceUrl:"https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"

          });
          mapView.ui.add(new Expand({ view: mapView, content: printWidget }), "top-right");

          const layerList = new LayerList({ view: mapView });
          mapView.ui.add(new Expand({ view: mapView, content: layerList }), "top-right");
        });
      } catch (err) {
        console.error("Error initializing map:", err);
        setLoading(false);
      }
    };

    initializeMap();

    return () => {
      if (mapView) {
        mapView.destroy();
        setView(null);
      }
    };
  }, [authData]);

  useEffect(() => {
    if (!view || !view.map) return;

    const handleZoomAndFilter = async () => {


      // const queryAndZoom = async (url, whereClause) => {

      //   console.log("queryAndZoom called with URL:", url);
      //   console.log("whereClause", whereClause);

      //   const layer = new FeatureLayer({ url });
      //   const query = new Query({
      //     where: whereClause,
      //     returnGeometry: true,
      //     outSpatialReference: view.spatialReference
      //   });

      //   const result = await layer.queryFeatures(query);
      //   if (result.features.length > 0) {
      //     const feature = result.features[0];
      //     const graphic = new Graphic({
      //       geometry: feature.geometry,
      //       symbol: {
      //         type: "simple-fill",
      //         color: [0, 0, 0, 0], // Hollow fill
      //         outline: { color: [0, 150, 255], width: 2 }
      //       }
      //     });

      //     view.graphics.removeAll();
      //     view.graphics.add(graphic);
      //     await view.goTo(feature.geometry.extent.expand(1.5));
      //   }
      // };



      const queryAndZoom = async (url, whereClause) => {
        console.log("queryAndZoom called with URL:", url);
        console.log("whereClause", whereClause);

        const layer = new FeatureLayer({ url });
        const query = new Query({
          where: whereClause,
          returnGeometry: true,
          outSpatialReference: view.spatialReference
        });

        const result = await layer.queryFeatures(query);
        if (result.features.length > 0) {
          const feature = result.features[0];
          const graphic = new Graphic({
            geometry: feature.geometry,
            symbol: {
              type: "simple-fill",
              color: [0, 0, 0, 0], // Hollow fill
              outline: { color: [0, 150, 255], width: 2 }
            }
          });

          view.graphics.removeAll();
          view.graphics.add(graphic);
          await view.goTo(feature.geometry.extent.expand(1));
        }
      };

     // let defExp = "1=1";
       let defExp = "";
     

      if (isDistCd) {
        defExp = `dist_cd = '${isDistCd}'`;

        await queryAndZoom(
          "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3",
          defExp
        );

        if (isUlbCd) {
          const ulbExp = `ulb_cd = '${isUlbCd}'`;
          defExp += ` AND ${ulbExp}`;
          console.log("ulbExp defExp", defExp);

          await queryAndZoom(
            "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5",
            defExp
          );
          await queryAndZoom(
            "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/FeatureServer/5",
            defExp
          );

          if (isWardNo) {
            const wardExp = `wardno = '${isWardNo}'`;
            defExp += ` AND ${wardExp}`;

          await queryAndZoom(
            "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7",
            defExp
          );
          await queryAndZoom(
            "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/FeatureServer/7",
            defExp
          );
          }
        }
      }


      view.map.allLayers.forEach(layer => {
        if (layer.type === "feature" && !(layer.parent?.title === "Master Plan")) {
          layer.definitionExpression = defExp;
        }
      });

    };

    handleZoomAndFilter();
  }, [view, isDistCd, isUlbCd, isWardNo]);






  useEffect(() => {
    const handleResize = () => {
      setIsScreenSize1(window.innerWidth <= 991)
    };
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])



  const calculatedHeight = useMemo(() => {
    const hasFeatureTableData = setFeatureTable?.length > 0;
    if (isWidth && isByDefaultActive) {
      return "calc(100vh - 78px)"; // Adjust height as needed
    }
    if (isScreenSize1) {
      return tabLocation === "/user-chatbot" ? "calc(100vh - 200px)" : "calc(80vh - 78px)";
    }
    if (tabLocation) {
      return "calc(100vh - 78px)";
    }
    if (isDrag) {
      return "0px";
    }
    if (isWidth) {
      return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
    }
    if (isWidth) {
      return "calc(100vh - 78px)"
    }
    if (!isWidth && hasFeatureTableData) {
      return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
    }
    if (!isWidth && hasFeatureTableData && isByDefaultActive) {
      return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
    }
    if (isBufferWidth && isToolHeight) {
      return "calc(100vh - 110px)"
    }
    if (isToolHeight) {
      return "calc(100vh - 108px)"
    }

    return "calc(100vh - 200px)";
  }, [tabLocation, isDrag, isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight]);




  const handleAccordian = (index) => {
    if (selectedBuffer === index) {
      dispatch(setSelectedBuffer(null));
      setIsDrag(true);
      setIsAccordian(null);
    } else {
      // Open the clicked accordion
      dispatch(setSelectedBuffer(index));
      setIsDrag(true);
      setIsAccordian(index);
    }

  };

  const handleToggleBufferWidth = () => {
    dispatch(setIsBufferWidth(!isBufferWidth));
  };
  const handleToggleBufferLeft = () => {
    dispatch(setIsSidebar(!isSideBar));
  };



  return (
    < div className='position-relative'>
      <Loader isLoader={loading} />
      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: calculatedHeight,
          overflow: "hidden",
        }}
      />

      {currentStageValue === 0 ? "" :
        <div className={isWidth ? "d-none" : 'manage-buffer'} type="button" onClick={handleToggleBufferWidth}>
          <div className={isBufferWidth ? 'not-rotate' : 'is-rotate'}>
            <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
          </div>
        </div>
      }
      {currentStageValue === 0 ? "" :
        <div className={isWidth ? "d-none" : 'manage-buffer-left'} type="button" onClick={handleToggleBufferLeft}
        >
          <div className={isBufferWidth ? 'is-rotate' : 'not-rotate'}>
            <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
          </div>
        </div>
      }



      {!isByDefaultActive && (
        <div className="position-relative">
          {location.pathname !== "/user-chatbot" && setFeatureTable.length > 0 && (
            <div className={isDrag ? 'isDragdiv' : 'dragdiv'} type="button" onClick={handleDrag}>
              <div className={isDrag ? 'not-rotate' : 'is-rotate'}>
                <img src="img/drag.svg" alt='drag' height="12px" width="12px" />
              </div>
              <div>
                <h6 className="viewmoretitle">{isDrag ? "View less data" : "View more data"}</h6>
              </div>
            </div>
          )}


        </div>
      )}
    </div>
  );
};

export default MapUlbView;
